// extracted by mini-css-extract-plugin
export var blink = "_an-2";
export var cursor = "_an-1";
export var reactMarkdown = "_an-3";
export var streamingText = "_an-0";